import React from 'react';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import StatusAlertCard from './StatusAlertCard';

function KoStatusAlert({ insuranceRequest }) {
  return (
    <StatusAlertCard tone="danger" icon={faXmark} title="Preventivo in KO">
      {insuranceRequest?.ko_reason && (
        <p>
          <strong>Motivo: </strong>
          {insuranceRequest.ko_reason}
        </p>
      )}
    </StatusAlertCard>
  );
}

export default KoStatusAlert;
